import { Amplify } from 'aws-amplify';
import { Suspense } from 'react';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';

import 'src/shared/i18n';

import { amplifyConfiguration } from '@/shared/aws-export';
import { GlobalStyle } from '@/shared/components/ui/global-style/global-style.styled';
import { Toast } from '@/shared/components/ui/toast/toast';
import { AppThemeProvider } from '@/shared/features/theme-switcher/context/theme-context';
import { UserUiPreferencesApiContext } from '@/shared/features/user-ui-preferences/context/user-ui-preferences-api-context';
import { useAuthListener } from '@/shared/hooks/use-auth-listener/use-auth-listener';
import store from '@/shared/redux/store/store';

import { backofficeUserUiPreferencesApi } from './config/backoffice-user-ui-preferences-api';
import { AppProvider } from './provider/provider';
import { AppRouter } from './router';

Amplify.configure(
  amplifyConfiguration({
    userPoolId: import.meta.env.VITE_APP_AWS_BACKOFFICE_USER_POOL_ID,
    userPoolClientId: import.meta.env
      .VITE_APP_AWS_BACKOFFICE_USER_POOLS_WEB_CLIENT_ID,
  }),
);

export const App = () => {
  useAuthListener();

  return (
    <Provider store={store}>
      <AppThemeProvider>
        <GlobalStyle />
        <Toast />
        {/* Above the router: the error route and the tenant-inner tree are the super-user too. */}
        <UserUiPreferencesApiContext value={backofficeUserUiPreferencesApi}>
          <AppProvider>
            {/* useTranslation suspends until the detected language's chunk has loaded; only English is bundled */}
            <Suspense fallback={null}>
              <AppRouter />
            </Suspense>
          </AppProvider>
        </UserUiPreferencesApiContext>
      </AppThemeProvider>
    </Provider>
  );
};
